<div style="background-color: white;">
    <div *ngFor="let medication of medications" class="medication-line">
        <mat-divider class="medication-divider"></mat-divider>
        <app-medication-row [record]="medication" class="medication-row"></app-medication-row>
    </div>
</div>